import React, { useState } from 'react'

import Rajat_Pic from '../../assets/images/people/Rajat.webp';
import Umair_Pic from '../../assets/images/people/Umair.webp';
import Dr_E_Circle_Pic from '../../assets/images/people/Dr_E_Circle.webp';
import Loren_Pleet_Pic from '../../assets/images/people/Loren_Pleet.webp';
import rightArrow from '../../assets/images/mains/rightArrow.svg';


const Testimonial = () => {
    const [showMoreStories, setShowMoreStories] = useState(false);
    const stories = {
        ONE: {
            title: "Unbelievably Good!",
            desc: "This technology is unbelievably good! The persona based nudges not only improved the number of orders but also the individual order sizes.",
            img: Loren_Pleet_Pic,
            name: "Loren Pleet",
            designation: "President (CA Furniture Store)"
        },
        TWO:{
            title: "We have a great tool!",
            desc: "Retargeting is dead! This is the best tool I found for improving conversion instead.",
            img: Dr_E_Circle_Pic,
            name: "Dr. Erson Religioso",
            designation: "Founder (Edge Mobility System)"
        },
        THREE: {
            title: "Awesome Services!",
            desc: "CausalFunnel helps us analyze millions of visitors and provides insights into our user behavior across sessions and journeys. Their DeepID product is a game-changer to enhance the user experience for repeat visitors/users and even stitching sessions when cookies are wiped-out. Their team genuinely cares about optimizing user experience and conversions for organizations and goes above and beyond to make sure this happens.",
            img: Rajat_Pic,
            name: "Rajat Agarwal",
            designation: "VP, Engineering (YourMechanic)"
        },
        
        FOUR : {
            title: "Know Your Customers!",
            desc: "We serve two types of persona and didn’t know how many of our visitors classify in each of them. CF’s AI used the visitor behavior and gave us details about how many of each persona type were we getting.",
            img: Umair_Pic,
            name: "Umair Tazeem",
            designation: "CEO (Embold)"
        },
    }

    const toggleStories = () => {
        setShowMoreStories(!showMoreStories)
    }

  return (
    <div className='testimonial-container my-5' x-data="{scrollTop:true}" >
        <div className='container flex-col'>
            <div className='section-title custStories'> <h2 className='custTitle'>Testimonials</h2></div>
            {/* <div className='bg-color-block' x-intersect="$el.classList.add('scale-parallax')" x-ref="storiesDiv"> */}
            <div className='bg-color-block' x-ref="storiesDiv">
                <Customer 
                    title={stories.ONE.title}
                    desc={stories.ONE.desc}
                    authIcon={stories.ONE.img}
                    authName={stories.ONE.name}
                    authDesig={stories.ONE.designation}
                    cls="stories1"
                />
                <Customer 
                    title={stories.TWO.title}
                    desc={stories.TWO.desc}
                    authIcon={stories.TWO.img}
                    authName={stories.TWO.name}
                    authDesig={stories.TWO.designation}
                    cls="stories2"
                />
                <Customer 
                    title={stories.THREE.title}
                    desc={stories.THREE.desc}
                    authIcon={stories.THREE.img}
                    authName={stories.THREE.name}
                    authDesig={stories.THREE.designation}
                    cls={showMoreStories ? "stories3 blurHide" : "blurContent stories3"}
                    onClick_Handler={toggleStories}
                />
                <Customer 
                    title={stories.FOUR.title}
                    desc={stories.FOUR.desc}
                    authIcon={stories.FOUR.img}
                    authName={stories.FOUR.name}
                    authDesig={stories.FOUR.designation}
                    cls={showMoreStories ? "scale-parallax stories4" : "d-none"}
                    onClick_Handler={toggleStories}
                    //   cls={showMoreStories ? "stories4 blurHide" : "blurContent stories4"}
                />
              </div>
              <div style={{ visibility:"hidden" }} >
                  {" Read more "} {" "} <img
                      src={rightArrow}
                      className="img-container"
                  alt="right-arrow"/>
              </div>
        </div>
    </div>
  )
}

export default Testimonial


export const Customer = (props) => {
    const { title, desc, authIcon, authName, authDesig, cls, onClick_Handler } = props;
    return (
        // <div className={`${cls} customer`} x-intersect="$el.classList.add('scale-parallax')" onClick={onClick_Handler}>
        <div className={`${cls} customer`} onClick={onClick_Handler}>
            <h3>{title}</h3>
            <p className='cust-desc-limit'>{desc}</p>
            <div className='customer-details'>
                <div className='cust-img-container'>
                    <img className='img-fluid' src={authIcon} alt="customer-pic"/>
                </div>
                <div className='cust-name-desig flex-col'>
                    <h4>{authName}</h4>
                    <p>{authDesig}</p>
                </div>
            </div>
        </div>
    )
}